module.exports = __webpack_public_path__ + "4fa924276c3712f5dfaaeeca936fa787.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sharing-center/shared-notes/shared-notes.html
// module id = 1720
// module chunks = 0